// imports
import { useParams } from 'react-router-dom';
import React, { FC, SyntheticEvent, useCallback, useEffect, useState } from 'react';
import { Box, Grid, Tab, Tabs, Typography } from '@mui/material';

// components
import EditStaff from './EditStaffForm';
import TabPanel from 'components/common/TabPanel';
import Invoice from 'components/main/Settings/Invoice';
import CurrentPlan from 'components/main/Settings/PaymentMethods/CurrentPlan/index';

// helpers, interfaces, constants
import { ParamType } from 'interfaces';
import { BillingIcon, PaymentIcon, ProfileIcon } from 'assets/svgs';
import { UserPayload, useGetUserLazyQuery } from 'generated/graphql';
import {
  EDIT_STAFF_TEXT,
  HTTP_STATUS,
  INVOICES_TEXT,
  StaffDetailTabs,
  SUBSCRIPTION_TEXT,
  STAFF_DETAILS_TEXT,
} from 'constants/index';

const ViewStaff: FC = () => {
  const { id } = useParams<ParamType>();
  const [user, setUser] = useState<UserPayload['user']>(null);
  const [value, setValue] = useState(StaffDetailTabs.EDIT_INFO);

  const handleChange = (_: SyntheticEvent, newValue: StaffDetailTabs) => {
    setValue(newValue);
  };

  const [getUser] = useGetUserLazyQuery({
    onCompleted: (data) => {
      const { getUser } = data || {};
      const { response, user } = getUser || {};
      const { status } = response || {};
      if (status === HTTP_STATUS.SUCCESS) {
        setUser(user as UserPayload['user']);
      }
    },
    onError: () => {
      setUser(null);
    },
  });

  const fetchUser = useCallback(async () => {
    await getUser({
      variables: {
        getUserInput: { id: id ?? '' },
      },
    });
  }, [getUser, id]);

  useEffect(() => {
    id && fetchUser();
  }, [fetchUser, id]);

  return (
    <Box mb={2}>
      <Typography variant="h5" mb={1}>
        {STAFF_DETAILS_TEXT}
      </Typography>
      <Tabs value={value} onChange={handleChange} aria-label="staff details tabs">
        <Tab
          value={StaffDetailTabs.EDIT_INFO}
          label={EDIT_STAFF_TEXT}
          icon={ProfileIcon}
          iconPosition="start"
        />

        <Tab
          value={StaffDetailTabs.SUBSCRIPTION}
          label={SUBSCRIPTION_TEXT}
          icon={PaymentIcon}
          wrapped
          iconPosition="start"
        />
        <Tab value={StaffDetailTabs.INVOICES} label={INVOICES_TEXT} icon={BillingIcon} iconPosition="start" />
      </Tabs>
      <TabPanel value={StaffDetailTabs.EDIT_INFO} activeTab={value}>
        <EditStaff id={id} user={user} />
      </TabPanel>
      <TabPanel value={StaffDetailTabs.SUBSCRIPTION} activeTab={value}>
        <Grid container>
          <Grid item xs={12} md={8}>
            <CurrentPlan />
          </Grid>
        </Grid>
      </TabPanel>
      <TabPanel value={StaffDetailTabs.INVOICES} activeTab={value}>
        <Invoice />
      </TabPanel>
    </Box>
  );
};

export default ViewStaff;
